















































































import Vue from 'vue';
import Component from 'vue-class-component';
import { Watch } from 'vue-property-decorator';
import Header from '@/mainPage/Header.vue';
import Sidebar from '@/mainPage/Sidebar.vue';
import Error404 from '@/views/Error404.vue';
import GlobalSnackbar from './components/GlobalSnackBar.vue';
import {
  Global,
  Props,
  User,
  MapSettings,
  Reports,
  Groups,
  ProjectStreams,
  Projects,
  Companies,
  Schedules
} from './store';
import API, { Types } from './modules/API';
import Utils from './modules/Utils';
import { getExpiringSchedules } from './modules/ScheduleUtils';
import Notifications from './components/Notifications.vue';
import PropUtils from './modules/PropUtils';
import moment from 'moment';
import vuex from '@/store';
import store from 'store';
import { initGoogleMaps } from './plugins/google-maps';
import MQTT from '@/modules/MQTT';
import MessageDialog from '@/components/dialogs/MessageDialog.vue';
import EditUserProfileDialog from '@/components/dialogs/EditUserProfileDialog.vue';
import ExpiringSchedulesDialog from '@/components/dialogs/ExpiringSchedulesDialog.vue';
import VersionUpdateDialog from '@/components/VersionUpdateDialog.vue';
import { VersionService } from '@/services/VersionService';

@Component({
  components: {
    Notifications,
    Header,
    Sidebar,
    GlobalSnackbar,
    Error404,
    MessageDialog,
    EditUserProfileDialog,
    ExpiringSchedulesDialog,
    VersionUpdateDialog
  }
})
class App extends Vue {
  @MapSettings.State('isLoading') isMapLoading;
  @MapSettings.Action('setLoading') setMapLoading;
  @MapSettings.Action('loadUserProperties') loadUserProperties;
  @Groups.Action('load') fetchGroups;
  @Global.State('mqtt_version_by_class') mqtt_version_by_class;
  @Global.State('isLoading') isFirstLoading;
  @Global.State('lang') lang;
  @Global.State('isMobile') isMobile;
  @Global.State('notify') notify;
  @Global.State('isSidebarOpen') isSidebarOpen;
  @Global.State('contentStyles') contentStyles;
  @Global.State('timezone') projectTimezone;
  @Global.State('allProjectsTimezone') allProjectsTimezone;
  @Global.State('show_not_allowed_user_dialog') show_not_allowed_user_dialog;
  @Global.State('show_forbidden_roles_dialog') show_forbidden_roles_dialog;
  @Global.Action('setMobile') setMobile;
  @Global.Action('loadDeviceClasses') loadDeviceClasses;
  @Global.Mutation('setNotAllowedUserDialog') setNotAllowedUserDialog;
  @Global.Mutation('setForbiddenRolesDialog') setForbiddenRolesDialog;
  @Global.Mutation('setTimezone') setTimezone;
  @Global.Mutation('setIsSidebarOpen') setIsSidebarOpen;
  @Global.Mutation('setContentStyles') setContentStyles;
  @Global.Mutation('setAllProjectsTimezone') setAllProjectsTimezone;
  @Global.Mutation('setMqttVersions') setMqttVersions;
  @User.State('project') project;
  @User.State('isAuth') isAuth;
  @User.State('notifications') notifications;
  @User.State('user_profile') user_profile;
  @User.Mutation('setIsLoading') setIsLoading;
  @User.Action('logout') logout;
  @User.Action('fetchProjectsData') fetchProjectsData;
  @User.Action('fetchUserProfile') fetchUserProfile;
  @Props.State('list') projectProperties;
  @Props.Mutation('clearMetaDeviceOptions') clearMetaDeviceOptions;
  @Reports.Action('loadReports') loadDevices;
  @Reports.State('reportsList') devices;
  @Reports.Getter('commissionedCabinets') commissionedCabinets;
  @Reports.Mutation('clearDevicesCount') clearDevicesCount;
  @Reports.Action('resetReports') resetReports;
  @ProjectStreams.Action('fetchControlNextActivation') fetchControlNextActivation;
  @ProjectStreams.Action('fetchDigitalInput') fetchDigitalInput;
  @Companies.State('companies_list') companies_list;
  @Companies.Mutation('setSelectedCompany') setSelectedCompany;
  @Companies.Mutation('setCompaniesList') setCompaniesList;
  @Projects.State('list') projects;
  @Projects.State('projects_count') projects_count;
  @Projects.Action('getAlerts') getAlerts;
  @Projects.Action('getEvents') getEvents;
  @Schedules.Action('loadSchedules') loadSchedules;
  @Schedules.State('schedules') schedules;

  time = '';
  // notification = '';
  language = '';
  mqtt = MQTT.instance;
  __clockTimeoutId: ReturnType<typeof setTimeout> | null = null;
  __expiringSchedulesTimeoutId: ReturnType<typeof setTimeout> | null = null;
  // Long enough for the project view to finish painting behind it, short enough that
  // the warning still reads as part of entering the project.
  EXPIRING_SCHEDULES_DIALOG_DELAY = 10000;
  __loadingProjectId: string | null = null;
  all_projects_timezone_calculated = false;
  not_allowed_user_message = 'Oops something went wrong, please login again';
  forbidden_roles_message =
    'Access denied. Your account does not have permission to access this dashboard. Please contact an admin for clarifications.';
  show_user_profile_dialog = false;
  show_expiring_schedules_dialog = false;
  expiring_schedules = [];
  show_version_dialog = false;
  new_version = '';

  get containerStyles() {
    return {
      'flex': this.$route.meta.container && this.$route.meta.container.fit,
      'd-flex': this.$route.meta.container && this.$route.meta.container.flex
    };
  }

  async mounted() {
    const user = store.get('user');

    if (Utils.getIdleTimeInMinutes() >= 90) {
      this.setIsLoading(false);
      this.setMapLoading(false);
      return;
    }
    this.language = this.lang;

    const isCerbosWithoutCompany = user && user.role === 'XX'
      && user.allowed_companies && Object.keys(user.allowed_companies).length > 1
      && !user.company;
    if (!this.projects.length && !isCerbosWithoutCompany) {
      this.fetchProjectsData();
    }
    if (user && user.allowed_companies && !Object.keys(this.companies_list).length) {
      if (user.company) {
        this.setSelectedCompany(user.company);
      }
      this.setCompaniesList(user.allowed_companies);
    }

    this.loadProjectData();
    this.onMobileChanged(this.$vuetify.breakpoint.name);

    // Start version checking for every visitor — authenticated or not.
    // Customers stuck on a stale `index.html` (broken styles) often land on
    // the login screen first; if we only start the check after auth they
    // have no way to recover without manually clearing cache.
    if (!VersionService.isLocalhost()) {
      this.initializeVersionChecking();
    }
  }

  initializeVersionChecking() {
    VersionService.initialize((newVersion: string) => {
      this.new_version = newVersion;
      this.show_version_dialog = true;
    });
  }

  onVersionDialogDismissed() {
    this.show_version_dialog = false;
  }

  closeNotification() {
    vuex.commit('User/closeNotification', this.notifications[0].time);
  }

  @Watch('projects.length')
  updateUserLogin() {
    if (this.projects.length === this.projects_count) {
      this.setIsLoading(false);
    }
  }

  // @Watch('notifications')
  // setNotification() {
  //   if (this.notifications && this.notifications.length > 0) {
  //     this.notification = this.notifications[0].message;
  //   } else {
  //     this.notification = '';
  //   }
  // }

  // @Watch('$route.path')
  // setPath(newVal, oldVal) {
  //   if (newVal !== '/sign' && this.isAuth) {
  //     vuex.dispatch('User/getProjectNotifications');
  //   } else {
  //     this.notification = '';
  //   }
  // }

  @Watch('isAuth')
  updateContentStyles(newAuth: boolean, oldAuth: boolean) {
    this.setContentStyles();
    
    // Initialize version checking when user logs in (if not already initialized)
    if (newAuth && !oldAuth && !VersionService.isLocalhost()) {
      const user = store.get('user');
      if (user) {
        this.initializeVersionChecking();
      }
    }
  }

  onMobileStateChanged() {
    this.setIsSidebarOpen(!this.isMobile);
    this.setContentStyles();
  }

  onNotAllowedUserDialogClosed() {
    this.logout();
    this.setNotAllowedUserDialog(false);
  }

  onForbiddenRolesDialogClosed() {
    this.logout();
    this.setForbiddenRolesDialog(false);
  }

  @Watch('$vuetify.breakpoint.name')
  onMobileChanged(breakpoint_name) {
    const is_mobile = breakpoint_name === 'xs' || breakpoint_name === 'sm' || breakpoint_name === 'md' ? true : false;
    this.setMobile(is_mobile);
    this.$nextTick(() => this.onMobileStateChanged());
  }

  async loadProjectData() {
    if (this.isAuth && this.project && !this.show_not_allowed_user_dialog) {
      // Re-entrancy guard: `loadProjectData` can be invoked from both `mounted`
      // and the `@Watch('project')` watcher in the same tick during initial
      // app boot (Vuex hydration races with Vue mount). Without this guard,
      // two parallel `getAllDevices` streams push devices into `reportsList`
      // and the Total counter visibly grows past the true device count
      // (the second stream resets the array mid-flight, but the first
      // stream's NDJSON reader keeps pushing). Tracking the project id of
      // the in-flight load lets us skip the duplicate call while still
      // allowing genuine project switches to re-load.
      if (this.__loadingProjectId === this.project.id) return;
      this.__loadingProjectId = this.project.id;

      this.getAlerts();
      this.getEvents();
      try {
        this.setMapLoading(true);
        await this.loadUserProperties({ id: this.project && this.project.id });
        this.$nextTick(() => initGoogleMaps(this.lang));
        this.setMapLoading(false);

        this.fetchUserProfile();
        this.updateProjectTimezone();
        this.updateClock();
        this.fetchGroups({ project_id: this.project.id });
        this.checkExpiringSchedules();

        Utils.setDocumentFavicon(this.project.id, this.projectProperties);
        Utils.setDocumentTitle(this.$route, this.project);

        this.resetReports();
        this.clearDevicesCount();
        this.clearMetaDeviceOptions();
        this.loadDevices({ ...this.project });
        if (this.project.id !== 'allProjects') {
          this.fetchDigitalInput();
          this.fetchControlNextActivation();
        }
      } catch (error) {
        console.log('Err', error);
        this.setMapLoading(false);
      }
    }
    this.mqtt.disconnect();
  }

  /*
    Entering a project is the only moment the user is warned about schedules that are
    about to reach the end of their configured dates. The dialog is not remembered
    anywhere on purpose: dismissing it only applies to the current project entry, and it
    comes back the next time the project is entered while schedules still qualify.
  */
  async checkExpiringSchedules() {
    this.clearExpiringSchedulesTimer();
    this.show_expiring_schedules_dialog = false;
    this.expiring_schedules = [];

    // Schedules are configured per project, so there is nothing to check on "All Projects".
    if (!this.project || this.project.id === 'allProjects') return;

    const project_id = this.project.id;
    // Project properties are already loaded at this point, which is where schedules live.
    await this.loadSchedules({ projectId: project_id });
    const expiring_schedules = getExpiringSchedules(this.schedules, this.projectTimezone);
    if (!expiring_schedules.length) return;

    this.__expiringSchedulesTimeoutId = setTimeout(() => {
      this.__expiringSchedulesTimeoutId = null;
      // The project can be left or switched while the delay is pending, and the next
      // project runs its own check - showing this one's schedules then would be wrong.
      if (!this.project || this.project.id !== project_id) return;
      this.expiring_schedules = expiring_schedules;
      this.show_expiring_schedules_dialog = true;
    }, this.EXPIRING_SCHEDULES_DIALOG_DELAY);
  }

  clearExpiringSchedulesTimer() {
    if (this.__expiringSchedulesTimeoutId) {
      clearTimeout(this.__expiringSchedulesTimeoutId);
      this.__expiringSchedulesTimeoutId = null;
    }
  }

  @Watch('user_profile')
  checkUserProfile() {
    if (
      this.user_profile &&
      (!this.user_profile.first_name || !this.user_profile.last_name)
    ) {
      this.show_user_profile_dialog = true;
    }
  }

  @Watch('project')
  async onProjectChanged(newProject, oldProject) {
    if (this.isAuth && this.project) {
      if (oldProject && oldProject.id !== newProject.id) {
        vuex.commit('Projects/clearAlertsCache');
        vuex.commit('Projects/clearEventsCache');
      }
      this.setMqttVersions(new Map());
      this.loadDeviceClasses();
      this.loadProjectData();
    } else if (!this.project) {
      // Project was unset (e.g. logout). Reset the re-entrancy guard so a
      // subsequent login to the same project id will trigger a fresh load.
      this.__loadingProjectId = null;
    }
  }
  @Watch('projects')
  async updateProjectTimezone() {
    if (this.projectProperties && this.projectProperties.length) {
      const timezonePropery = PropUtils.getProperty(this.projectProperties, 'project.timezone');
      const value = timezonePropery ? timezonePropery.value.timezone : '';
      if (!value) {
        Utils.showNotify('error', 'Error!', 'There is no timezone property in this project. Please contact with support team.');
      } else {
        this.setTimezone(value);
      }
    } else if (
      this.project &&
      this.project.id === 'allProjects' &&
      !this.allProjectsTimezone &&
      this.projects.length &&
      !this.all_projects_timezone_calculated
    ) {
      this.all_projects_timezone_calculated = true;
      let projects_timezone = await this.fetchTimezoneProperty();
      projects_timezone = projects_timezone
        ? projects_timezone.hasOwnProperty('timezone')
          ? projects_timezone.timezone
          : projects_timezone
        : 'Asia/Tel_Aviv';

      this.setAllProjectsTimezone(projects_timezone);
    }
  }

  async fetchTimezoneProperty() {
    const property = await API.get(
      Types.COMPANIES,
      `${this.projects[0].company}/${Types.PROJECTS}/${this.projects[0].id}/properties`,
      { name: 'project.timezone' }
    );
    return property &&
      property.results &&
      property.results[0] &&
      property.results[0].value
      ? property.results[0].value
      : '';
  }

  updateClock() {
    if (!this.projectTimezone) return;
    // Cancel any pending tick from a previous run. `updateClock` is invoked
    // from `loadProjectData`, which fires again on project switch — without
    // this guard, multiple self-rescheduling timers would race and overwrite
    // `this.time` out of phase, causing visible flicker.
    if (this.__clockTimeoutId) {
      clearTimeout(this.__clockTimeoutId);
      this.__clockTimeoutId = null;
    }

    const tick = () => {
      if (!this.project) {
        this.__clockTimeoutId = null;
        return;
      }
      if (this.projectTimezone) {
        this.time = moment().tz(this.projectTimezone).format('HH:mm:ss');
      }
      // Self-reschedule against the next wall-clock second instead of using
      // setInterval(_, 1000). setInterval drifts and, more importantly, drops
      // queued callbacks when the main thread is blocked for >1s (streaming
      // chunks, icon recomputes, MQTT cascades). That made the clock pause
      // and then jump forward several seconds at once. Self-rescheduling
      // realigns to the wall clock on every tick, so even after a long
      // block we resume cleanly without skipping the displayed seconds
      // beyond what truly elapsed.
      const msUntilNextSecond = 1000 - (Date.now() % 1000);
      this.__clockTimeoutId = setTimeout(tick, msUntilNextSecond);
    };

    tick();
  }

  beforeDestroy() {
    if (this.__clockTimeoutId) {
      clearTimeout(this.__clockTimeoutId);
      this.__clockTimeoutId = null;
    }
    this.clearExpiringSchedulesTimer();
  }

  @Watch('notify') onGotNotify() {
    if (this.notify) {
      this.$notify({
        type: this.notify.type,
        text: this.notify.text,
        title: this.notify.title
      });
    }
  }

  @Watch('lang')
  updateContentStyle() {
    this.setContentStyles();
    this.language = this.lang;
    if (this.lang !== localStorage.getItem('lang')) {
      localStorage.setItem('lang', this.lang);
      window.location.reload();
    }
  }
}

export default App;
